import React from "react";

export default function MacroTable(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover table-sm text-center">
        <thead className="thead-dark">
          <tr className="">
            <th colSpan="4">Macronutrients per meal</th>
          </tr>
          <tr className="">
            <th className="macro-width" />
            <th className="macro-width">Proteins</th>
            <th className="macro-width">Carbs</th>
            <th className="macro-width">Fat</th>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <th>Meal 1</th>
            <th>{Math.round(props.protein / props.meals)}</th>
            <th>{Math.round(props.carbs / props.meals)}</th>
            <th>{Math.round(props.fat / props.meals)}</th>
          </tr>
          <tr>
            <th>Meal 2</th>
            <th>{Math.round(props.protein / props.meals)}</th>
            <th>{Math.round(props.carbs / props.meals)}</th>
            <th>{Math.round(props.fat / props.meals)}</th>
          </tr>
          <tr>
            <th>Meal 3</th>
            <th>{Math.round(props.protein / props.meals)}</th>
            <th>{Math.round(props.carbs / props.meals)}</th>
            <th>{Math.round(props.fat / props.meals)}</th>
          </tr>
          <tr style={{ display: props.meals <= 3 ? "none" : "" }}>
            <th>Meal 4</th>
            <th>{Math.round(props.protein / props.meals)}</th>
            <th>{Math.round(props.carbs / props.meals)}</th>
            <th>{Math.round(props.fat / props.meals)}</th>
          </tr>
          <tr style={{ display: props.meals <= 4 ? "none" : "" }}>
            <th>Meal 5</th>
            <th>{Math.round(props.protein / props.meals)}</th>
            <th>{Math.round(props.carbs / props.meals)}</th>
            <th>{Math.round(props.fat / props.meals)}</th>
          </tr>
        </tbody>
        {console.log(props)}
      </table>
      <div className=''>

      <h6 className="w-75 mx-auto text-center">
        If you want to choose a product from the protein-fat table, choose
        distribution of macronutrients from the table below. You can pick it
        instead of regular meal.
      </h6>
      </div>
      <table className="table table-striped table-bordered table-hover table-sm text-center">
        <thead className="thead-dark">
          <tr className="">
            <th className="macro-width" />
            <th className="macro-width2">Carbs</th>
            <th className="macro-width2">Protein-fat *</th>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <th>Meal</th>
            <th>{Math.round(props.carbs / props.meals)} grams</th>
            <th>
              {Math.round((props.protein * 4 + props.fat * 9) / props.meals)}{" "}
              kcal
            </th>
          </tr>
        </tbody>
      </table>
      <h6 className="small text-center">
        {" "}
        * the value is described in calories because proteins and fats have different calorific value and it is not possible to present these two macronutrients in the form of grams per meal.{" "}
      </h6>
    </div>
  );
}
